import type { CustomValidatorResponse, ICustomFunctionValueType } from "@ceeferenderer/fe-renderer-sdk";
import { RsCustomValidation } from "@ceeferenderer/fe-renderer-sdk";
import { ics } from "./icsGen";

RsCustomValidation.bind({
  TelephoneNumber: (value: ICustomFunctionValueType, _argument: unknown, element?: Element) => {
    let match = true;
    value = value ? value.toString() : "";
    let validatorResult: CustomValidatorResponse;
    const input: any = element;
    if (value) {
      const phoneRegex = /^(?:\+1)?(?:\(\d{3}\)|\d{3})[ -]?\d{3}[ -]?\d{4}$/;
      match = phoneRegex.test(value);
      validatorResult = {
        message: input?.getAttribute("data-invalid-message"),
        value: match,
      };
    } else {
      validatorResult = {
        message: input?.getAttribute("data-validation-message"),
        value: false,
      };
    }
    return validatorResult;
  },
  email: (value: ICustomFunctionValueType, _argument?: unknown, element?: Element) => {
    let match = true;
    value = value ? value.toString() : "";
    let validatorResult: CustomValidatorResponse;
    const input: any = element;
    if (value) {
      const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@([a-zA-Z0-9-]+)\.[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      match = emailRegex.test(value);
      validatorResult = {
        message: input?.getAttribute("data-invalid-message"),
        value: match,
      };
    } else {
      validatorResult = {
        message: input?.getAttribute("data-validation-message"),
        value: false,
      };
    }
    return validatorResult;
  },
  exportIcs: () => {
    console.warn("inside export ics");
    const cal_single = ics();
    console.warn(`check clall single ${cal_single}`);
    if (cal_single) {
      const icsSubject: any = document.getElementById("icsSubject")?.textContent;
      const icsDescription: any = document
        .getElementById("icsDescription")
        ?.textContent?.trimStart()
        .replaceAll("\n", "\\n");
      const icsAppointmentStartDateTime: any = document
        .getElementById("icsAppointmentStartDate")
        ?.textContent?.toLowerCase();
      const icsAppointmentEndDateTime: any = document
        .getElementById("icsAppointmentEndDate")
        ?.textContent?.toLowerCase();
      const icsAppointmentDate: any = document.getElementById("icsAppointmentDate")?.textContent;
      const icsAppointmentLocation: any = document.getElementById("icsAppointmentLocation")?.textContent;
      const icsTimezone: any = document.getElementById("icsTimezone")?.textContent;
      const icsAttendee: any = document.getElementById("icsAttendee")?.textContent;
      const icsEmailId: any = document.getElementById("icsEmailId")?.textContent;
      if (
        icsAppointmentStartDateTime &&
        icsAppointmentStartDateTime !== "" &&
        icsAppointmentEndDateTime &&
        icsAppointmentEndDateTime !== ""
      ) {
        const today = new Date(icsAppointmentDate);
        const dd: any = today.getDate();
        const mm: any = today.getMonth() + 1;
        const yyyy = today.getFullYear();
        const convertedApptDateStr: any = `${mm}/${dd}/${yyyy}`;
        const convertedStartDateStr: any = `${convertedApptDateStr} ${icsAppointmentStartDateTime.trim()}`;
        const convertedEndDateStr: any = `${convertedApptDateStr} ${icsAppointmentEndDateTime.trim()}`;
        cal_single.addEvent(
          icsSubject.trim(),
          icsDescription,
          icsAppointmentLocation.trim(),
          convertedStartDateStr,
          convertedEndDateStr,
          icsTimezone.trim(),
          icsAttendee.trim(),
          icsEmailId.trim()
        );
        console.warn(
          `ics data${icsSubject.trim()}${icsDescription}${icsAppointmentLocation.trim()}${convertedStartDateStr}${convertedEndDateStr}${icsTimezone.trim()}${icsAttendee.trim()}${icsEmailId.trim()}`
        );
        // cal_single.addEvent(
        //   "Best Day",
        //   "This is the best day to demonstrate a single event.",
        //   "New York",
        //   "8/7/2013 5:30 pm",
        //   "8/7/2013 6:00 pm",
        //   undefined
        // );
        cal_single.download("AppointmentEvent", ".ics");
      }
      return {
        message: "exit and refresh",
        value: true,
      };
    } else {
      return {
        message: "exit and refresh",
        value: true,
      };
    }
  },
  refreshPage: () => {
    return {
      message: "exit and refresh",
      value: true,
    };
  },
  returnToStorePage: () => {
    const result: any = {
      message: "exit and refresh",
      value: true,
    };
    window.open("https://www.xfinity.com/local/store-offers", "_self");
    return result;
  },
});
